import { recordPath, recordRoute } from '@/shared/registry'

/** Where the LTI tool pages live. */
export const ltiToolsPath = '/launch/lti-tools'
export const createLtiToolPath = `${ltiToolsPath}/new`
export const ltiToolRoute = recordRoute('launch', 'lti-tools')
export const editLtiToolRoute = `${ltiToolRoute}/edit`

/** The page with the URLs to give a tool's vendor. */
export const ltiPlatformPath = '/launch/lti-platform'

/** A tool's details page. */
export function ltiToolPath(id: string): string {
  return recordPath('launch', 'lti-tools', id)
}

/** The base of LTI Tool Details' slots (`detailsSlots`). */
export const ltiToolDetailsSlot = 'launch.lti-tool-details'

/** The API's tool endpoints. */
export const ltiToolsApi = '/launch/v1/lti-tools'

export function ltiToolApi(id: string): string {
  return `${ltiToolsApi}/${encodeURIComponent(id)}`
}

/** The tools an author may put in an LTI link. */
export const ltiToolChoicesApi = `${ltiToolsApi}/choices`

/** Starts adding content to a course from a tool (LTI deep linking). */
export const ltiDeepLinksApi = '/launch/v1/lti/deep-links'

/** Where the tool's window comes back to on the author's site; the API sends it there. */
export const deepLinkReturnPath = '/launch/lti/deep-link-return'

/** The platform's URLs, and rotating its signing key. */
export const ltiPlatformApi = '/launch/v1/lti/platform'
export const rotateLtiKeysApi = '/launch/v1/lti/keys/rotate'

/** The permissions the pages need. */
export const readLtiToolsPermission = 'launch.lti-tools.read'
export const writeLtiToolsPermission = 'launch.lti-tools.write'
export const deleteLtiToolsPermission = 'launch.lti-tools.delete'
